var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import Select from "react-select";
var SubjectSelector = function (props) {
    var options = props.subjects
        .map(function (subject) { return ({ value: subject.id, label: subject.name }); })
        .sort(function (a, b) { return (a.label > b.label ? 1 : -1); });
    var selectedOption = options.find(function (option) { return option.value === props.activeSubjectId; });
    var customStyles = {
        dropdownIndicator: function (base) { return (__assign(__assign({}, base), { color: "#6e7075" // Custom colour
         })); }
    };
    return (React.createElement("div", { className: "csd-selector subject" },
        React.createElement("label", { className: "label", htmlFor: "subject-selector" }, "Subject:"),
        React.createElement(Select, { styles: customStyles, "aria-label": "subject-selector", "aria-labelledby": "subject-selector", id: "subject-selector", name: "subject-selector", className: "csd-react-select", classNamePrefix: "csdrs", value: selectedOption, onChange: function (event) { return props.onSubjectChange(event.value); }, options: options })));
};
export default SubjectSelector;
